import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-switch-confirm-dialog',
  templateUrl: './switch-confirm-dialog.component.html',
  styleUrls: ['./switch-confirm-dialog.component.scss']
})
export class SwitchConfirmDialogComponent {
  @Input() state = false
  @Input() header = 'Заголовок'
  @Input() description = 'Описание'
  @Input() buttonText = 'Описание'

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  confirmEvent() {
    this.onConfirm.emit()
    this.closeModal()
  }
}
